import React from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import AlertMessage from '../../components/AlertMessage'
import PageLoader from '../../components/PageLoader'
import usersActions from './actions'

class RemoveConfirmationModal extends React.Component {
  componentDidUpdate(prevProps) {
    const { onToggle, removingStatus } = this.props
    const { removingStatus: prevRemovingStatus } = prevProps

    if (prevRemovingStatus === 'removing' && removingStatus === 'succeeded') {
      onToggle()
    }
  }

  handleSubmit(event) {
    const { id, dispatch } = this.props

    event.preventDefault()

    dispatch(usersActions.remove(id))
  }

  render() {
    const {
      removingError,
      removingStatus,
      modalIsOpen,
      onToggle,
      t
    } = this.props

    return (
      <Modal isOpen={modalIsOpen} toggle={() => onToggle()}>
        <Form>
          <ModalHeader toggle={() => onToggle()}>
            {t('RemoveConfirmationModal.title')}
          </ModalHeader>
          <ModalBody>
            {t('RemoveConfirmationModal.message')}

            {(removingStatus === 'removing') && (
              <PageLoader message={t('RemoveConfirmationModal.removing')} />
            )}

            {removingStatus === 'failed' && (
              <AlertMessage>{removingError}</AlertMessage>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => onToggle()}>
              {t('buttons.cancel', { ns: 'commons' })}
            </Button>
            <Button
              color="danger"
              onClick={(event) => this.handleSubmit(event)}
              type="submit"
            >
              {t('RemoveConfirmationModal.buttons.confirm')}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    )
  }
}

RemoveConfirmationModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string,
  modalIsOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  removingError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  removingStatus: PropTypes.string,
  t: PropTypes.func.isRequired
}

RemoveConfirmationModal.defaultProps = {
  id: null,
  removingError: null,
  removingStatus: 'idle'
}

const mapStateToProps = ({
  users: {
    removingError,
    removingStatus
  }
}) => ({
  removingError,
  removingStatus
})

export default withTranslation(['UsersPage', 'commons'])(
  connect(mapStateToProps)(RemoveConfirmationModal)
)
